﻿import React, { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { reducedMotion } from '../../hooks/useLenis.js';
import './Accordion.css';

export const Accordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const panelsRef = useRef([]);

  const toggleItem = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    panelsRef.current.forEach((panel, i) => {
      if (!panel) return;
      const isOpen = openIndex === i;

      if (isOpen) {
        gsap.to(panel, {
          height: 'auto',
          duration: reducedMotion() ? 0 : 0.5,
          ease: 'power2.inOut',
          onComplete: () => ScrollTrigger.refresh(),
        });
      } else {
        gsap.to(panel, {
          height: 0,
          duration: reducedMotion() ? 0 : 0.4,
          ease: 'power2.inOut',
          onComplete: () => ScrollTrigger.refresh(),
        });
      }
    });
  }, [openIndex]);

  return (
    <div className="accordion">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={index} className="acc-item" data-acc-item>
            <button
              className="acc-trigger"
              type="button"
              data-acc-trigger
              aria-expanded={isOpen}
              onClick={() => toggleItem(index)}
            >
              <span>{item.title}</span>
              <span className="acc-sign" aria-hidden="true" />
            </button>
            <div
              className="acc-panel"
              data-acc-panel
              ref={(el) => {
                panelsRef.current[index] = el;
              }}
              style={{ height: index === 0 ? 'auto' : 0, overflow: 'hidden' }}
            >
              <div className="acc-panel-inner prose">{item.content}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};